
    import { Component, Prop, PropSync } from 'vue-property-decorator';
    import Navigation from '@/components/Navigation/Navigation.vue';
    import { VListGroup } from 'vuetify/lib/components';

    @Component({
        components: {
            VListGroup,
        },
    })
    export default class NavigationDrawer extends Navigation {
        @PropSync('drawer') public drawerInput!: boolean;
        @Prop({ default: () => 256 }) public width!: number;
    }
